import { render, staticRenderFns } from "./publication.vue?vue&type=template&id=b2d44de8&scoped=true"
import script from "./publication.vue?vue&type=script&lang=js"
export * from "./publication.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=b2d44de8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d44de8",
  null
  
)

export default component.exports